export const NiveisAcesso = {
    PARCEIRO: 1,
    CLIENTE: 2,
    CREDENCIADO: 3,
    ADMIN: 4,
    RESPONSAVEL: 5,
    TRABALHADOR: 6,
    REPRESENTANTE: 7
};

